import "./style.scss";
import { Slide, toast } from "react-toastify";
import { GetNotifications } from "../redux/features/notifications/notificationActions";
import Swal from "sweetalert2";

export const commonSwtichCases = (id: any, searchValue: any, dispatch: any) => {
    searchValue = encodeURIComponent(searchValue)
    console.log('id >>>> ', id);

    switch (id) {
        case 'Notification':
            dispatch(GetNotifications({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        default:
    }
}

export const conFirmMessage = (values) => {
    return Swal.fire(values)
}

export const docUrl = (images: any) => {
    const urlArray: any = [];
    for (let i = 0; i < images.length; i++) {
        urlArray.push(images[i].url);
    }
    return urlArray
}

export const toastifyOptions: any = {
    position: "top-center",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Slide,
};

export const notify = (message: any, type: any) => {
    if (type === 'error') {
        return toast.error(message, toastifyOptions);
    } else if (type === 'info') {
        return toast.info(message, toastifyOptions);
    } else if (type === 'warning') {
        return toast.warning(message, toastifyOptions);
    } else if (type === 'success') {
        return toast.success(message, toastifyOptions);
    }
};

export const successMessage = (message: string) => {
    toast.success(message);
}

export const errorMessage = (message: string) => {
    toast.error(message)
}
